export const GeneralSettingsEN = {
  "applicationConfig": {
    "title": "General settings"
  },
  "applicationLeaveConfig": {
    "pageHeader": {
      "leave": "LEAVE APPLICATION",
      "sub": "Allow user-account to create leave application"
    },
    "input": {
      "hour": "Use hourly leave application\n",
      "maxDay": "Maximum number of days to apply after leaving",
      "minDay": "Minimum number of days to apply before leaving",
      "description": "Describe the leave applications",
      "config": "Reason for leave application"
    },
    "label": {
      "accept": "Allow user-account to create leave application",
      "acceptDetail": "Turn off if your company doesn't use this form.",
      "hour": "Use hourly leave application",
      "hourDetail": "When this setting is enabled, the system will allow the user-account to create an hourly leave application instead of choosing the first half, the second half.",
      "maxDay": "Maximum number of days to apply after leaving",
      "maxDayDetail": "Example: If you set the number of days as 2, an employee who wants to take leave from July 4, 2020, can only creat an application no later than July 6, 2020.",
      "minDay": "Minimum number of days to apply before leaving",
      "minDayDetail": "Example: If you set the number of days as 2, an employee who wants to take leave from July 4, 2020, must creat an application 2 days in advance, which is July 2, 2020.",
      "description": "Describe the leave applications",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation.",
      "config": "Reason for leave application"
    }
  },
  "applicationAbsenceConfig": {
    "pageHeader": {
      "absence": "ABSENCE APPLICATION",
      "sub": "Allow user-account to create the hourly leave application"
    },
    "input": {
      "hour": "Sử dụng đơn vắng mặt theo giờ",
      "maxDay": "Maximum number of days to apply after hourly leaving",
      "minDay": "Minimum number of days to apply before hourly leaving",
      "description": "Describe the hourly leave application",
      "config": "Reason for absence application"
    },
    "label": {
      "accept": "Allow user-account to create the hourly leave application",
      "acceptDetail": "Turn off if your company doesn't use this form.",
      "hour": "Sử dụng đơn vắng mặt theo giờ",
      "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn vắng mặt theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
      "maxDay": "Maximum number of days to apply after hourly leaving",
      "maxDayDetail": "Example: If you set the number of days as 2, an employee who wants to take leave from July 4, 2020, can only creat an application no later than July 6, 2020.",
      "minDay": "Minimum number of days to apply before hourly leaving",
      "minDayDetail": "Example: If you set the number of days as 2, an employee who wants to take leave from July 4, 2020, have to creat an application 2 days in advance, which is July 2, 2020.",
      "description": "Describe the hourly leave application",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation.",
      "config": "Reason for absence application"
    }
  },
  "applicationShiftMoreConfig": {
    "pageHeader": {
      "shiftMore": "SHIFT MORE REQUEST",
      "sub": "Allow user-account to create the shift-registration more request"
    },
    "input": {
      "maxDay": "Maximum number of days to apply after working overtime",
      "minDay": "Minimum number of days to apply before working overtime",
      "description": "Describe the shift-registration more request"
    },
    "label": {
      "accept": "Allow user-account to create the shift-registration more request",
      "acceptDetail": "Turn off when your company don't use this form",
      "maxDay": "Maximum number of days to apply after working overtime",
      "maxDayDetail": "Example: If you set the number of days as 2, an employee who works overtime from July 4, 2020, can only creat an application no later than July 6, 2020.",
      "minDay": "Minimum number of days to apply before working overtime",
      "minDayDetail": "Example: If you set the number of days as 2, an employee who works overtime from July 4, 2020, have to creat an application 2 days in advance, which is July 2, 2020.",
      "description": "Describe the shift-registration more request",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation."
    }
  },
  "applicationInoutConfig": {
    "pageHeader": {
      "inout": "CHECKIN/OUT REQUEST",
      "sub": "Allow user-account to create the checkin/out request"
    },
    "input": {
      "day": "Number of days allowed to create an application after forgetting to check in/out",
      "description": "Describe the checkin/out request",
      "config": "Reason for checkin/out request"
    },
    "label": {
      "accept": "Allow user-account to create the checkin/out request",
      "acceptDetail": "Turn off if your company doesn't use this form.",
      "day": "Number of days allowed to create an application after forgetting to check in/out",
      "dayDetail": "Example: If you set the number of days as 2, an employee who wants to creat Checkin/out application on July 4, 2020, have to do it no later than July 6, 2020.",
      "description": "Describe the checkin/out request",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation.",
      "config": "Reason for checkin/out request"
    }
  },
  "applicationShiftChangeConfig": {
    "pageHeader": {
      "shiftChange": "SHIT CHANGE REQUEST",
      "sub": "Allow user-account to create the shit change request"
    },
    "input": {
      "maxDay": "Maximum number of days to apply after swapping shift-registration",
      "minDay": "Minimum number of days to apply before swapping shift-registration",
      "description": "Describe the shit change request"
    },
    "label": {
      "accept": "Allow user-account to create the shit change request",
      "acceptDetail": "Turn off if your company doesn't use this form",
      "maxDay": "Maximum number of days to apply after swapping shift-registration",
      "maxDayDetail": "Example: If you set the number of days as 2, an employee who wants to swap shift-registration from July 4, 2020, can only create an application no later than July 6, 2020",
      "minDay": "Minimum number of days to apply before swapping shift-registration",
      "minDayDetail": "Example: If you set the number of days as 2, an employee who wants to swap shift-registration from July 4, 2020, have to creat an application 2 days in advance, which is July 2, 2020.",
      "description": "Describe the shit change request",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation."
    }
  },
  "applicationShiftRegisterConfig": {
    "pageHeader": {
      "shiftRegister": "SHIFT REGISTRATION REQUEST",
      "sub": "Allow user-account to create the shift-registration registration request"
    },
    "input": {
      "maxDay": "Maximum number of days to apply after registering shift-registration",
      "minDay": "Minimum number of days to apply before registering shift-registration",
      "description": "Describe the shift-registration registration request",
      "config": "Lý do đăng ký ca"
    },
    "label": {
      "accept": "Allow user-account to create the shift-registration registration request",
      "acceptDetail": "Turn off if your company doesn't use this form.",
      "maxDay": "Maximum number of days to apply after registering shift-registration",
      "maxDayDetail": "Example: If you set the number of days as 2, an employee who wants to register from July 4, 2020, can only creat an application no later than July 6, 2020.",
      "minDay": "Minimum number of days to apply before registering shift-registration",
      "minDayDetail": "Example: If you set the number of days as 2, an employee who wants to register from July 4, 2020, have to creat an application 2 days in advance, which is July 2, 2020.",
      "description": "Describe the shift-registration registration request",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation."
    }
  },
  "applicationWorkTimeConfig": {
    "pageHeader": {
      "workTime": "FLEXIBLE WORKING HOURS REQUEST",
      "sub": "Allow user-account to create flexible working hours request"
    },
    "input": {
      "maxDay": "Maximum number of days to apply after leaving",
      "minDay": "Minimum number of days to apply before leaving",
      "description": "Describe the worktime regime",
      "config": "Reason for flexible hour request"
    },
    "label": {
      "accept": "Allow user-account to create flexible working hours request",
      "acceptDetail": "Turn off when your company don't use this form",
      "maxDay": "Maximum number of days to apply after leaving",
      "maxDayDetail": "Example: If you set the number of days as 2, an employee who wants to take leave from July 4, 2020, can only creat an application no later than July 6, 2020.",
      "minDay": "Minimum number of days to apply before leaving",
      "minDayDetail": "Example: If you set the number of days as 2, an employee who wants to take leave from July 4, 2020, have to creat an application 2 days in advance, which is July 2, 2020.",
      "description": "Describe the worktime regime",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation.",
      "config": "Reason for flexible hour request"
    }
  },
  "applicationResignConfig": {
    "pageHeader": {
      "resign": "RESIGNATION APPLICATION",
      "sub": "Allow user-account to create resignation application"
    },
    "input": {
      "description": "Describe the resignation forms",
      "config": "Reason for resignation application"
    },
    "label": {
      "accept": "Allow user-account to create resignation application",
      "acceptDetail": "Turn off if your company doesn't use this form",
      "description": "Describe the resignation forms",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation.",
      "config": "Reason for resignation application"
    }
  },
  "applicationOtherConfig": {
    "pageHeader": {
      "other": "OTHER SETTINGS",
      "sub": "Cho phép người dùng tạo đơn cài đặt khác"
    },
    "input": {
      "isAcceptLate": "Sử dụng đơn cài đặt khác theo giờ",
      "creatorAllowed": "Số ngày tối đa có thể làm đơn sau thời điểm cài đặt khác",
      "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm cài đặt khác",
      "description": "Mô tả đơn cài đặt khác khi tạo đơn",
      "config": "Lý do cài đặt khác"
    },
    "label": {
      "autoChange": "The time for the system to automatically switch the approval status from pending to rejected after closing the application",
      "autoChangeDetail": "After closing the request on the timesheet, if there are still pending requests, then the approval becomes meaningless.\nWith this feature, the system will automatically cancel suspensions requests, helping free up system memory.",

      "isAcceptLate": "Do not allow users to edit application after the expiration date",
      "isAcceptLateDetail": "When this setting is enabled, users cannot edit the form they have created if the editing time is outside the time allowed to create the form.",

      "creatorAllowed": "Personnel who is allowed to create the application for someone else",
      "creatorAllowedDetail": "Cho phép chọn Selecting personnel who are allowed to create applications for others.\nThe \"All HR\" option means all employees can create for each other.\nWhen no option is selected, the system will take permissions in application module, the management rights are allowed to creare form./07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020"

    },
    "option": {
      "oneDay": "1 day",
      "threeDays": "3 days",
      "unlimited": "Unlimited",
      "all": "All",
      "company": "Company management",
      "branch": "Brand management",
      "department": "Department management",
      "allHumanResource": "All Human Resource"
    }
  },
  "applicationMissionConfig": {
    "pageHeader": {
      "mission": "MISSIONS APPLICATION",
      "sub": "Allow user-account to create missions application"
    },
    "input": {
      "maxDay": "Maximum number of days to apply after going on a business trip",
      "minDay": "Minimum number of days to apply before going on a business trip",
      "description": "Describe the missions application",
      "config": "Reason for missions application"
    },
    "label": {
      "accept": "Allow user-account to create missions application",
      "acceptDetail": "Turn off if your company doesn't use this form",
      "maxDay": "Maximum number of days to apply after going on a business trip",
      "maxDayDetail": "Example: If you set the number of days as 2, an employee who goes on a business trip from July 4, 2020, can only create an application no later than July 6, 2020.",
      "minDay": "Minimum number of days to apply before going on a business trip",
      "minDayDetail": "Example: If you set the number of days to 2, an employee who goes on a business trip from July 4, 2020, have to creat an application 2 days in advance, which is July 2, 2020.",
      "description": "Describe the missions application",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation.",
      "config": "Reason for missions application",
      "feeAmount": "Fees for missions",
      "mission-vehicle": "Vehicle for missions"
    }
  },
  "applicationOvertimeConfig": {
    "pageHeader": {
      "overtime": "OVERTIME REQUEST",
      "sub": "Allow user-account to create the overtime request"
    },
    "input": {
      "maxDay": "Maximum number of days to apply after working overtime",
      "minDay": "Minimum number of days to apply before working overtime",
      "description": "Mô tả đơn làm thêm khi tạo đơn",
      "config": "Lý do làm thêm"
    },
    "label": {
      "accept": "Allow user-account to create the overtime request",
      "acceptDetail": "Turn off when your company doesn't use this form",
      "maxDay": "Maximum number of days to apply after working overtime",
      "maxDayDetail": "Example: If you set the number of days as 2, an employee who works overtime from July 4, 2020, can only create an application no later than July 6, 2020.",
      "minDay": "Minimum number of days to apply before working overtime",
      "minDayDetail": "Example: If you set the number of days as 2, an employee who works overtime from July 4, 2020, have to creat an application 2 days in advance, which is July 2, 2020.",
      "description": "Describe the overtime request",
      "descriptionDetail": "When this setting is enabled, user-account needs to enter description then the system will record a successful new creation."
    }
  }
}
